import { useNotification } from "../contexts/NotificationContext";

const ICON_CONFIG = {
  success: { icon: 'bi bi-check-circle-fill', color: '#16a34a' },
  danger:  { icon: 'bi bi-x-circle-fill',     color: '#dc3545' },
  warning: { icon: 'bi bi-exclamation-triangle-fill', color: '#f59e0b' },
  info:    { icon: 'bi bi-info-circle-fill',   color: '#0ea5e9' },
};

const Notification = () => {
  const { toasts, removeToast } = useNotification();

  if (toasts.length === 0) return null;

  return (
    <div
      className="toast-container position-fixed bottom-0 end-0 p-3"
      style={{ zIndex: 9999 }}
    >
      {toasts.map(toast => {
        const config = ICON_CONFIG[toast.type] || ICON_CONFIG.info;
        return (
          <div
            key={toast.id}
            className="toast show align-items-center border mb-2 bg-white"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
          >
            <div className="d-flex">
              <div className="toast-body d-flex align-items-center gap-2">
                <i className={config.icon} style={{ color: config.color, fontSize: '1.1rem' }}></i>
                <span className="text-dark">{toast.text}</span>
              </div>
              <button
                type="button"
                className="btn-close me-2 m-auto"
                onClick={() => removeToast(toast.id)}
                aria-label="Fechar"
              />
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Notification;
